"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var core_1 = require("@material-ui/core");
var usePlatformConfig_1 = require("../../../common/react/usePlatformConfig");
var useWidgetContext_1 = require("../../../common/react/useWidgetContext");
var useCheckoutContext_1 = require("../../common/hooks/useCheckoutContext");
var useGetConfigurationUrl_1 = require("../../common/hooks/useGetConfigurationUrl");
var useBackLink = function () {
    var _a, _b, _c, _d;
    var checkout = usePlatformConfig_1.default().platformConfig.checkout;
    var checkout4 = core_1.useTheme().checkoutLite.checkout4;
    var backOverwrittenBasePath = (_a = checkout) === null || _a === void 0 ? void 0 : _a.backOverwrittenBasePath;
    var deal = useCheckoutContext_1.default().deal;
    var configuration = useWidgetContext_1.default().configuration;
    var getConfigurationUrl = useGetConfigurationUrl_1.default().getConfigurationUrl;
    var useChangeModelUrlFromCar = (checkout4 || {}).useChangeModelUrlFromCar;
    var carDms = (_d = (_c = (_b = deal) === null || _b === void 0 ? void 0 : _b.car) === null || _c === void 0 ? void 0 : _c.stock) === null || _d === void 0 ? void 0 : _d.dms;
    var isOverride = carDms && !!backOverwrittenBasePath;
    var changeModelUrl = useChangeModelUrlFromCar ? getConfigurationUrl() : configuration.spcURL;
    var backLinkUrl = isOverride ? "" + backOverwrittenBasePath + carDms : changeModelUrl;
    return { backLinkUrl: backLinkUrl, isOverride: isOverride, useChangeModelUrlFromCar: useChangeModelUrlFromCar };
};
exports.default = useBackLink;
